"use strict";

exports.__esModule = true;
exports.PLUGIN_PRIORITY = exports.PLUGIN_KEY = exports.CollapsibleColumns = void 0;
var _collapsibleColumns = require("./collapsibleColumns");
exports.PLUGIN_KEY = _collapsibleColumns.PLUGIN_KEY;
exports.PLUGIN_PRIORITY = _collapsibleColumns.PLUGIN_PRIORITY;
exports.CollapsibleColumns = _collapsibleColumns.CollapsibleColumns;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/collapsibleColumns/index.js
// module id = 1253
// module chunks = 0